import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function EntitiesPage(): JSX.Element | null {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/admin/academic", { replace: true });
  }, [navigate]);

  return null;
}
